function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.8333 16.25C26.8333 15.0074 27.8127 14 29.0208 14H47.9791C49.1873 14 50.1666 15.0074 50.1666 16.25V32H26.8333V16.25Z",
  stroke: "#322E87",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9167 32H53.0834V33.5C53.0834 35.9853 51.1246 38 48.7084 38H28.2917C25.8754 38 23.9167 35.9853 23.9167 33.5V32Z",
  stroke: "#322E87",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5 23.0834H18.5C17.2574 23.0834 16.25 24.1187 16.25 25.3959V51.6042C16.25 52.8814 17.2574 53.9167 18.5 53.9167H33.5C34.7426 53.9167 35.75 52.8814 35.75 51.6042V25.3959C35.75 24.1187 34.7426 23.0834 33.5 23.0834Z",
  fill: "white",
  stroke: "#322E87",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 27.7084H27.5",
  stroke: "#322E87",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23 49.2916H29",
  stroke: "#322E87",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 32,
  stroke: "#413C9D",
  strokeWidth: 4
});

var SvgIcon4 = function SvgIcon4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon4.a9f74569.svg";
export { ForwardRef as ReactComponent };